import faker from '@faker-js/faker';
import {TBuyerAmlPreference} from './types';

export const getAMLPreference = (): TBuyerAmlPreference => {
  return {
    preference_enabled: faker.datatype.boolean(),
    widget_threshold: faker.mersenne.rand(20),
  } as TBuyerAmlPreference;
};
